// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MbYqN","col":"styles_col__3IMQH"};